/* eslint-disable no-unused-vars */
import { Ref, ref, watchEffect } from '@vue/composition-api';

type ParseDataFn<T> = (value: string) => T;
type GenerateKeyFn<T> = (data: T) => string;

type Options<T> = {
  parseData?: ParseDataFn<T>
  generate?: GenerateKeyFn<T>
  queryRouter?: QueryRouter
}

export interface QueryRouter {
  getQuery(key: string): string;
  setQuery(key: string, value: string): void;
}

const defaultParseData = <T>(value: string) => value as T;
const defaultGenerate = <T>(data: T) => data ? String(data) : '';
export class HistoryQueryRouter implements QueryRouter {
  getQuery(key: string): string {
    return new URLSearchParams(window.location.search).get(key) || '';
  }
  setQuery(key: string, value: string): void {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    // 因为single-spa会拦截history的pushState和replaceState，所以需要调用原生的方法
    // oldHistoryReplaceState是在index.html中定义的
    Reflect.apply((window as any).oldHistoryReplaceState, window.history, [null, '', url]);
  }
}
export const defaultQueryRouter = new HistoryQueryRouter();

/**
 *
 * @param key URL 参数key
 * @param options.parseData 解析数据函数，通过参数value解析为业务数据
 * @param options.generate 把业务数据转换生成为参数key的值
 * @param options.queryRouter 获取路由参数和设置路由参数
 * @returns
 */
export const useUrlQueryRef = <T>(key: string, options?: Options<T>): Ref<T | undefined> => {
  const { parseData = defaultParseData, generate = defaultGenerate, queryRouter = defaultQueryRouter } = options || {};
  const data = ref<T>();
  // 获取URL参数
  const value = queryRouter.getQuery(key);
  if (value) {
    data.value = parseData(value);
  }
  // 当数据变化的时候重写
  watchEffect(() => {
    const value = data.value;
    if (!value) {
      return;
    }
    const val = generate(value);
    if (!val && !queryRouter.getQuery(key)) {
      return;
    }
    queryRouter.setQuery(key, val || '');
  });
  return data;
};
